/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Button, Modal } from "semantic-ui-react";
import { TextField } from '@mui/material';
import { ConfirmModal } from "../components/ConfirmModal";

//This component should provide the user experience (like the FEvIR Platform) after clicking the Reorganize Sections button
//The Reorganize Sections button should be provided in CompositionResourceDisplay (and the Add/Reorder/Delete buttons and related code should be removed)
//DONE The component should receive compositionResourceState.section and setCompositionResourceState as arguments and result in return {...prevState, "section": newSection}

//TODO 1 -- test existing code and fix bugs as needed
//TODO 2 -- apply the functions to the highest-level sections

//This component should also support reordering and deletion of top level sections

const deleteActionWithConfirm = (pathIndex, sectionWalk, editSectionModal, above, newValue = null,
    setConfirmModalState
) => {
    let confirmContent = "Do you wish to delete this section?";
    let label = getSectionLabel(sectionWalk.section[pathIndex], null);
    if (label) {
        confirmContent = "Do you wish to delete the section: \"" + label + "\"?";
    }
    if (sectionWalk.section[pathIndex].section) {
        if (label) {
            confirmContent = "Do you wish to delete the section: \"" + label + "\" and all subsections of it?";
        } else {
            confirmContent = "Do you wish to delete this section and all subsections of it?";
        }
    }
    setConfirmModalState(prevState => {
        return {
            ...prevState,
            "open": true,
            "content": confirmContent,
            "functionParameters": [sectionWalk, pathIndex],
            runFunction: deleteAction,
            saveFunction: null, buttonTextOkay: "Yes", buttonTextCancel: "No",
        }
    })
}

const deleteAction = ([sectionWalk, pathIndex]) => {
    sectionWalk.section.splice(pathIndex, 1);
}

const getSectionLabel = (section, defaultLabel = "[Section With No Label]") => {
    let label = section.title || section.display;   //section.title or if section is actually a CodeSystem concept and it's concept.display
    if (!label) {
        if (section.code?.text) {
            return section.code.text;
        }
        if (section.code?.coding) {
            for (let codingEntry of section.code.coding) {
                label = codingEntry.display || codingEntry.code;
                if (label) {
                    return label;
                }
            }
        }
    }
    return label || defaultLabel;
}

const changeLabel = (pathIndex, sectionWalk, editSectionModal, above, newValue) => {
    //NOTE the editSectionModal and above are not needed here but are needed to maintain the pattern across function calls
    const newSection = [...sectionWalk.section];
    newSection[pathIndex] = {
        ...newSection[pathIndex],
        "title": newValue
    };
    sectionWalk.section = newSection;
}

const deleteSection = (setSectionState, editSectionModal, setEditSectionModal, currentSectionPath, setConfirmModalState) => {
    setSectionState(prevState => {
        let sectionsToWalk = JSON.parse(JSON.stringify(prevState));
        walkingTheSections(sectionsToWalk, currentSectionPath, deleteActionWithConfirm, null, editSectionModal, null, setConfirmModalState);
        recursiveWalkToDelete(sectionsToWalk);
        let newSection = sectionsToWalk.section;
        return { ...prevState, "section": newSection, changesMade: true };
    });
    setEditSectionModal(prevState => { return { ...prevState, changesMade: true } });
}

const MoveSectionButton = ({ moveToSectionPath, setSectionState, editSectionModal, setEditSectionModal, above }) => {
    return <Button style={{ color: "#000000", padding: "4px" }} className="formButton sectionReorganizeButton"
        content="Move Here" onClick={() => {
            moveSectionToNewSection(moveToSectionPath, setSectionState, editSectionModal, above);
            if (!above) {
                if (!(editSectionModal?.movingPath.slice(0, editSectionModal?.movingPath?.length - 1).toString() === moveToSectionPath.slice(0, moveToSectionPath.length - 1).toString() && editSectionModal?.movingPath?.[editSectionModal.movingPath?.length - 1] < moveToSectionPath[moveToSectionPath.length - 1])) {
                    moveToSectionPath = JSON.parse(JSON.stringify(moveToSectionPath));
                    moveToSectionPath[moveToSectionPath.length - 1] += 1;
                }
            }
            setEditSectionModal(prevState => { return { ...prevState, moveMode: false, movingPath: undefined, newlyMovedPath: moveToSectionPath, newlyMovedLabel: getSectionLabel(prevState.movingSection), changesMade: true } });
        }} />
}

const markTheOldSectionLocation = (pathIndex, sectionWalk, editSectionModal, above, newValue) => {
    const newSection = [...sectionWalk.section];
    newSection[pathIndex] = {
        ...newSection[pathIndex],
        "DELETETHISAFTERMOVE": true
    };
    sectionWalk.section = newSection;
}

const placeSection = (pathIndex, sectionWalk, editSectionModal, above, newValue) => {
    let position = pathIndex + (above ? 0 : 1);
    sectionWalk.section = sectionWalk.section.slice(0, position)
        .concat(editSectionModal.movingSection, sectionWalk.section
            .slice(position));
}

const moveSectionToNewSection = (moveToSectionPath, setSectionState, editSectionModal, above) => {
    //editSectionModal.movingSection
    //set editSectionModal.newlyMovedPath  lastPathIndex + (above ? 0 : 1)
    //let position = lastPathIndex + (above ? 0 : 1);
    //let b = a.slice(0, position).concat("NEW", a.slice(position));
    setSectionState(prevState => {
        //editSectionModal.movingPath
        let sectionsToWalk = JSON.parse(JSON.stringify(prevState));
        walkingTheSections(sectionsToWalk, editSectionModal.movingPath, markTheOldSectionLocation, above, editSectionModal, null); //this one
        walkingTheSections(sectionsToWalk, moveToSectionPath, placeSection, above, editSectionModal, null);
        recursiveWalkToDelete(sectionsToWalk);
        let newSection = sectionsToWalk.section;
        return { ...prevState, "section": newSection };
    });
}

const walkingTheSections = (sectionsToWalk, path, runFunction, above = null, editSectionModal = null, newValue = null,
    setConfirmModalState = null
) => {
    let sectionWalk = sectionsToWalk;
    for (let index in path) {
        let pathIndex = path[index];
        if (parseInt(index) + 1 === path.length) {  //Meaning it's the last index in the path array
            if (!sectionWalk.section) {
                sectionWalk.section = [];
            }
            runFunction(pathIndex, sectionWalk, editSectionModal, above, newValue, setConfirmModalState);  //Crashes with markTheOldSectionLocation
        } else {
            sectionWalk = sectionWalk.section[pathIndex];
        }
    }
}

const recursiveWalkToDelete = (sectionWalk) => {
    for (let index in sectionWalk.section) {
        let section = sectionWalk.section[index];
        if (section["DELETETHISAFTERMOVE"]) {
            sectionWalk.section.splice(index, 1);
            break;
        } else if (section.section) {
            recursiveWalkToDelete(section);
        }
    }
}

const relabelSection = (setSectionState, editSectionModal, setEditSectionModal, currentSectionPath,
    newValue) => {

    setSectionState(prevState => {
        let sectionsToWalk = JSON.parse(JSON.stringify(prevState));
        walkingTheSections(sectionsToWalk, currentSectionPath, changeLabel, null, editSectionModal, newValue);
        let newSection = sectionsToWalk.section;
        return { ...prevState, "section": newSection, changesMade: true };
    });
    setEditSectionModal(prevState => { return { ...prevState, changesMade: true } });
}

const LabelOrChangeLabel = ({ currentSectionPath, label, sectionTitle, editSectionLabelMode, editSectionModal,
    setEditSectionModal, setSectionState }) => {
    return <>
        {/*We use section.title instead of label for editing of it*/}
        {(editSectionLabelMode && sectionTitle && !editSectionModal.moveMode) ?
            <TextField style={{ width: "80%" }} multiline className="inputField" type='text'
                size="small" variant='outlined' value={sectionTitle}
                onChange={(e) => {
                    relabelSection(setSectionState, editSectionModal, setEditSectionModal,
                        currentSectionPath, e.target.value);
                }} />
            :
            <b>{label}</b>
        }
    </>
}

const RecursiveSectionView = ({ json, sectionState, setSectionState, editSectionModal, setEditSectionModal,
    sectionPath, editSectionLabelMode, deleteSectionsMode, parentBeingMoved, setConfirmModalState }) => {
    return <div style={{ marginBottom: "12px" }}>
        {json.section.map((section, index) => {
            let currentSectionPath = sectionPath.concat(index);
            let label = getSectionLabel(section);
            let beingMoved = editSectionModal?.movingPath?.toString() === currentSectionPath.toString();
            let justMoved = editSectionModal?.newlyMovedPath?.toString() === currentSectionPath.toString() && editSectionModal.newlyMovedLabel === label;
            let allowDropHere = !beingMoved && editSectionModal?.moveMode && currentSectionPath.length > 1 && !parentBeingMoved;

            return <div key={index}>
                {(index === 0 && allowDropHere) &&
                    <div>
                        <MoveSectionButton moveToSectionPath={currentSectionPath} setSectionState={setSectionState}
                            editSectionModal={editSectionModal} setEditSectionModal={setEditSectionModal} above={true} />
                    </div>
                }
                <div style={{
                    outline: "1px solid #CCCCCC", margin: "4px", padding: "2px",
                    backgroundColor: beingMoved ? "#F8EC8B" : (justMoved && !editSectionModal.moveMode) && "#D5F6D5"
                }}>
                    {(!editSectionModal.moveMode && !editSectionModal.deleteSectionsMode) &&
                        <>
                            {currentSectionPath.length > 1 &&
                                <Button positive style={{ color: "#FFFFFF", marginLeft: "6px", padding: "4px" }}
                                    className="formButton sectionReorganizeButton"
                                    content="Move"
                                    onClick={() => {
                                        setEditSectionModal(prevState => {
                                            return {
                                                ...prevState,
                                                moveMode: true,
                                                movingPath: currentSectionPath,
                                                movingSection: JSON.parse(JSON.stringify(section))
                                            };
                                        });
                                    }} />
                            }
                        </>
                    }
                    <span>
                        <LabelOrChangeLabel currentSectionPath={currentSectionPath} label={label}
                            sectionTitle={section.title} editSectionLabelMode={editSectionLabelMode}
                            editSectionModal={editSectionModal} setEditSectionModal={setEditSectionModal}
                            setSectionState={setSectionState} />
                    </span>
                    {(editSectionModal.deleteSectionsMode && !editSectionModal.moveMode &&
                        currentSectionPath.length > 1) &&
                        <>
                            &nbsp;&nbsp;&nbsp;<span className={"unselectable"}
                                style={{ cursor: "pointer", fontWeight: "normal", fontSize: "32px", color: "#CC4444" }}
                                title="Delete This Section"
                                onClick={() => {
                                    deleteSection(setSectionState, editSectionModal, setEditSectionModal,
                                        currentSectionPath, setConfirmModalState);
                                }}><b>🗑</b>
                            </span>
                        </>}
                    <>{(editSectionModal.moveMode && beingMoved) &&
                        <> MOVING... <Button negative
                            style={{ color: "#FFFFFF", marginLeft: "6px", padding: "4px" }}
                            className="formButton sectionReorganizeButton"
                            content="Cancel Move"
                            onClick={() => {
                                setEditSectionModal(prevState => {
                                    return { ...prevState, moveMode: false, movingPath: undefined }
                                });
                            }} />
                        </>}</>
                    {(section?.section?.length > 0)
                        ?
                        <div style={{ marginLeft: "36px" }}>
                            <RecursiveSectionView json={section} sectionState={sectionState}
                                setSectionState={setSectionState} editSectionModal={editSectionModal}
                                setEditSectionModal={setEditSectionModal} sectionPath={currentSectionPath}
                                editSectionLabelMode={editSectionLabelMode} deleteSectionsMode={deleteSectionsMode}
                                parentBeingMoved={parentBeingMoved || beingMoved}
                                setConfirmModalState={setConfirmModalState} />
                        </div>
                        :
                        <>{(editSectionModal.moveMode && !beingMoved && !parentBeingMoved) &&
                            <div style={{ marginLeft: "36px" }}>
                                <MoveSectionButton moveToSectionPath={currentSectionPath.concat(0)}
                                    setSectionState={setSectionState} editSectionModal={editSectionModal}
                                    setEditSectionModal={setEditSectionModal} above={true} />
                            </div>}</>
                    }
                </div>
                {allowDropHere && <div><MoveSectionButton moveToSectionPath={currentSectionPath} setSectionState={setSectionState} editSectionModal={editSectionModal} setEditSectionModal={setEditSectionModal} above={false} /></div>}
            </div>
        })}
    </div>;
}

const ReorganizeSectionsModal = ({ editSectionModal,
    setEditSectionModal, sectionsReorganizedState, setSectionsReorganizedState }) => { 

    const [sectionState, setSectionState] = useState({});
    const [confirmModalState, setConfirmModalState] = useState({
        open: false, header: "Delete section",
        content: "Do you wish to delete this section and all subsections of it?",
        runFunction: deleteAction, "functionParameters": null,
        saveFunction: null, buttonTextOkay: "Yes", buttonTextCancel: "No",
        buttonColorOkay: "green", buttonColorCancel: "red"
    });

    const modalClose = () => {
        setEditSectionModal({ modalOpen: false });
    }

    useEffect(() => {
        if (sectionsReorganizedState.section) {
            setSectionState({
                "section": [{
                    "title": "The Composition Resource",
                    "section": sectionsReorganizedState.section
                }]
            });
        }
    }, []);

    let modalContent = <div style={{
        paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
        paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
        {confirmModalState.open &&
            <ConfirmModal confirmModalState={confirmModalState} setConfirmModalState={setConfirmModalState} />}
        <div style={{ float: "right" }}>
            {editSectionModal.changesMade ?
                <div>
                    <>
                        <Button className="formButton positive"
                            style={{ padding: "6px 40px", position: "absolute", right: "260px", zIndex: 10 }}
                            content="Apply Changes"
                            onClick={() => {
                                console.log(sectionState)
                                setSectionsReorganizedState({ "reorganized": true, "section": sectionState.section[0].section });
                                modalClose();
                            }}
                        />
                        <Button className="formButton negative"
                            style={{ padding: "6px", position: "absolute", right: "14px", zIndex: 10 }}
                            content="Cancel Changes" title="Close"
                            onClick={() => { modalClose(); }}
                        />
                    </>
                </div>
                :
                <>
                    {
                        (!editSectionModal.moveMode && !editSectionModal.editSectionLabelMode) &&
                        <>
                            {!editSectionModal.deleteSectionsMode &&
                                <>
                                    <Button style={{ color: "#000000", padding: "4px", marginRight: "40px" }}
                                        className="formButton sectionReorganizeButton"
                                        content="Choose a Section To Delete"
                                        onClick={() => {
                                            setEditSectionModal(prevState => { return { ...prevState, deleteSectionsMode: true } });
                                        }} />
                                </>
                            }
                            {(!editSectionModal.editSectionLabelMode && !editSectionModal.deleteSectionsMode) &&
                                <>
                                    <Button style={{ color: "#000000", padding: "4px", marginRight: "40px" }}
                                        className="formButton sectionReorganizeButton"
                                        content="Edit Section Titles"
                                        onClick={() => {
                                            setEditSectionModal(prevState => { return { ...prevState, editSectionLabelMode: true } });
                                        }} />
                                    &nbsp;&nbsp;&nbsp;</>
                            }
                        </>
                    }
                    <Button className="formButton negative"
                        style={{ padding: "6px", position: "absolute", right: "14px", zIndex: 10 }}
                        content="✖" title="Close"
                        onClick={() => { modalClose(); }}
                    />
                </>
            }
        </div>
        <br />
        {sectionState.section &&
            <div style={{ margin: "12px 0px" }}>
                <RecursiveSectionView json={sectionState} sectionState={sectionState}
                    setSectionState={setSectionState} editSectionModal={editSectionModal}
                    setEditSectionModal={setEditSectionModal} sectionPath={[]}
                    editSectionLabelMode={editSectionModal.editSectionLabelMode}
                    deleteSectionsMode={editSectionModal.deleteSectionsMode}
                    setConfirmModalState={setConfirmModalState} />
            </div>}
        <br />
    </div>;

    return (
        <Modal
            style={{ padding: "0px", margin: "0px" }}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            open={true}
            centered={false}
            content={modalContent}
        />
    )
}

export { ReorganizeSectionsModal };